import { Injectable } from '@angular/core';
import { forkJoin, map, Observable, shareReplay } from 'rxjs';
import { ProgramsStore } from './stores/programs.store';
import { UsersStore } from './stores/users.store';

@Injectable({ providedIn: 'root' })
export class InitialLoadingService {
  private init$?: Observable<void>;

  constructor(private programsStore: ProgramsStore, private usersStore: UsersStore) {}

  ensureLoaded(): Observable<void> {
    if (!this.init$) {
      this.init$ = forkJoin({
        programs: this.programsStore.load(),
        users: this.usersStore.load(),
      }).pipe(
        map(() => void 0),
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.init$;
  }
}
